import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { getNextMonth, getPrevMonth } from '../../../common/helper/commonHelper.js';

class DateSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentDate: new Date(),
        }
    }
    onClickDateBar = (e) => {
        let x = e.clientX - e.currentTarget.getBoundingClientRect().x;
        let width = e.currentTarget.getBoundingClientRect().width;
        if (x > (width / 2)) {
            let date = this.state.currentDate;
            date = getNextMonth(date);

            this.setState({ currentDate: date });
            if(this.props.onChange) {
                this.props.onChange(date);
            }
        } else {
            let date = this.state.currentDate;
            date = getPrevMonth(date);

            this.setState({ currentDate: date });
            if(this.props.onChange) {
                this.props.onChange(date);
            }
        }
    }

    getDisplayDate() {
        let arr = this.state.currentDate.toString().split(' ');

        return arr[1] + ' ' + arr[3];
    }

    render() {
        const date = this.getDisplayDate();
        return (
            <Body onClick={this.onClickDateBar} style={this.props.style} Display={this.props.Display}>
                <DateCtrl>
                    <i className="fas fa-chevron-left" />
                </DateCtrl>
                <div>
                    {date}
                </div>
                <DateCtrl>
                    <i className="fas fa-chevron-right" />
                </DateCtrl>
            </Body>
        );
    }
}

export { DateSelector };

DateSelector.propTypes = {
    style: PropTypes.object,
    onChange: PropTypes.func,
};

const Body = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    color: #888;
    width: calc(100% - 10px);
    padding: 2px 5px;
    display: ${props => props.Display ? "" : "none"};

`;
const DateCtrl = styled.div`
    padding: 0 5px;
    cursor: pointer;
`;
